module.exports = __webpack_public_path__ + "static/22-05d7115eb8266a3752faebec6e753bc6.jpg";